import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    TextField,
    DialogTitle
  } from '@mui/material';
  import { LoadingButton } from '@mui/lab';
  import React, { useState } from 'react';
  import { AppStore } from '../../stores/AppStore.js';
  import { saveNewDepartmentAPI } from '../../utils/apiFunctions';
  import { getDepartments } from '../../utils/getData.js';
  
  const NewDepartmentDialog = ({
    openAlert,
    setEmployeeFields,
    setEmployeeFieldsToUpdate,
    openDialogNewDepartment,
    handleCloseDialog,
  }) => {
    const [newDepartment, setNewDepartment] = useState('');
    const [isSaving, setIsSaving] = useState(false);
  
    const createNewDepartment = async (newDepartment) => {
      try {
        setIsSaving(true);
  
        AppStore.update(s => { s.loading = true });
  
        const response = await saveNewDepartmentAPI(newDepartment);
  
        if (response && response.status === 200) {
          setEmployeeFields(prev => ({
            ...prev,
            department: newDepartment,
            departmentId: response.data.id
          }));
          setEmployeeFieldsToUpdate(prev => ({
            ...prev,
            department: {department: newDepartment},
            department_id: response.data.id
          }));
        }
  
        openAlert(
          response.message,
          response && response.status === 200 ? 'success' : 'error'
        );
  
        handleCloseDialog();
      } catch (error) {
        console.error(error);
        openAlert('Failed to create department', 'error');
      } finally {
        setIsSaving(false);
        AppStore.update(s => { s.loading = false });
      }
    };
  
    return (
      <Dialog
        open={openDialogNewDepartment}
        aria-labelledby="alert-dialog-department"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add a new department</DialogTitle>
  
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Department name"
            placeholder="e.g. Lifecycle"
            helperText="Use proper capitalization. This will appear in the Directory."
            value={newDepartment}
            sx={{ mt: 1 }}
            onChange={(e) => setNewDepartment(e.target.value)}
          />
        </DialogContent>
  
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleCloseDialog}
            disabled={isSaving}
          >
            Cancel
          </Button>
  
          <LoadingButton
            loading={isSaving}
            variant="contained"
            disabled={!newDepartment?.trim() || isSaving}
            onClick={() => createNewDepartment(newDepartment.trim())}
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default NewDepartmentDialog;
  